import { render, staticRenderFns } from "./Item5Detail.vue?vue&type=template&id=98d351a8"
import script from "./Item5Detail.vue?vue&type=script&lang=js"
export * from "./Item5Detail.vue?vue&type=script&lang=js"
import style0 from "./Item5Detail.vue?vue&type=style&index=0&id=98d351a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports